 
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TextField, Grow, Button } from '@mui/material';
import CustomDialog from '../../../Components/Dialog/CustomDialog';

const ChangeBodyValueDialog = function ChangeBodyValueDialog({
  open = false,
  onClose = () => {},
  onSubmit = () => {},
}) {
  const intl = useIntl();
  const [value, setValue] = useState('');

  const handleChangeValue = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit(`§${open.innerText}§`, value);
  };

  useEffect(() => {
    if (open && open.innerText) {
      setValue(open.innerText);
    }
  }, [open]);

  return (
    <CustomDialog
      id="changeValue-dialog"
      open={Boolean(open)}
      close={onClose}
      fullWidth
      maxWidth="xs"
      transition={Grow}
      onSubmit={handleSubmit}
      title={intl.messages.SUBSTITUTE_VALUE}
      components={{
        actions: (
          <Button onClick={handleSubmit}>{intl.messages.CONFIRM}</Button>
        ),
      }}
    >
      <TextField
        id="changeValue-textfield"
        value={value}
        onChange={handleChangeValue}
        placeholder={`${intl.messages.INSERT} ${intl.messages.NEW_VALUE}`}
        fullWidth
      />
    </CustomDialog>
  );
};

ChangeBodyValueDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ChangeBodyValueDialog;
